
















import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../../store/edit';

export default Vue.extend({
	name: 'Poznamky',
	props: {
		storeUri: { type: String, default: null },
	},
	computed: {
		...genVuexComputeds(store),
	},
});
